export const LEARNER_LOGIN_WELCOME_STORE_KEY =
  "LearnerApp.Login.WelcomePageDisplay";

export const VISITED_CLUB_POST_PAGE_FROM_CLUB_HOME_PAGE_STORE_KEY =
  "LearnerApp.Club.VisitedPostPageFromHomePage";
